<template>
  <!--登录页面-->
  <tk-container
    class="b-g-f"
  >
    <!--登录表单-->
    <div style="height: 100%" class="login-container p-y-16">
      <!--登录-->
      <template>
        <tk-flex center column style="padding-top: 20%;">
          <tk-image size="contain" width="157" height="47" :src='logoImg'></tk-image>
        </tk-flex>
        <tkui-form class="p-x-15 form-mt" ref="logo">
          <div class="tkui-input-container input-placeholder">
            <div class="tkui-input-body-warp">
              <cleave
                :options="options"
                class="form-control tkui-input-body"
                v-model="telphone" type="tel"
                name="phone"
                style="font-size: 20px !important;"
                placeHolder="请输入手机号"
              ></cleave>
            </div>
          </div>
          <tkui-input
            rulers="required"
            type="number"
            style="font-size: 20px !important;"
            class="input-placeholder"
            mask="natural"
            v-model="telCode"
            placeHolder="请输入验证码"
          >
            <div
              class="btn-code"
              slot="right"
              :class="{'disabled-code': codeFailure}"
              @click="handleGetCode"
            >{{code}}</div>
          </tkui-input>
        </tkui-form>
        <!--登录按钮-->
        <tkui-button
          class="btn-mt" raised block primary rounded
          :disabled="loginDisabled"
          @click.native="handleTelLogin"
        >登录</tkui-button>
      </template>
      <!--有效账号可登录提示-->
      <div class="m-t-30 p-t-30">
        <tk-flex middle center>
          <div class="footer-line"></div>
          <div class="caption m-x-20">有效账号 方可登录</div>
          <div class="footer-line"></div>
        </tk-flex>
        <tk-flex middle center class="footer-type m-t-24">
          <tk-flex
            column
            class="footer-type-margin-l"
            @click.native="$push('/common/registered')"
          >
            <tk-avatar size="50" class="footer-type-margin-l-avatar"><tk-icon size="26" color="#DCBD7C">zhanghaoshenqing</tk-icon></tk-avatar>
            <div class="font-12 m-t-10">账号申请</div>
          </tk-flex>
          <div class="caption m-x-20" style="width: 50px;"></div>
          <tk-flex
            column
            class="footer-type-margin-r"
            @click.native="$push('/common/changeAccount')"
          >
            <tk-avatar size="50" class="footer-type-margin-l-avatar"><tk-icon size="26" color="#DCBD7C">zhanghaobiangeng</tk-icon></tk-avatar>
            <div class="font-12 m-t-10">账号变更</div>
          </tk-flex>
        </tk-flex>
        <tk-flex center class="m-t-32 footer-caption">登录即代表您已同意账号使用协议和隐私政策</tk-flex>
      </div>
    </div>
  </tk-container>
</template>
<script>
import 'cleave.js/src/addons/phone-type-formatter.i18n'
export default {
  data () {
    return {
      logoImg: 'https://s3.moke.cloud/dianpei/34f4984f-33e3-4117-b91a-1aac03665ca7.png', // logo
      loginDisabled: false, // 登录按钮状态
      agreementValue: true, // 同意协议状态
      codeFailure: false, // 验证码disabled样式
      codeStatus: 1, // 验证码状态
      code: '获取验证码', // 验证码描述
      options: {
        phone: true,
        phoneRegionCode: 'CN'
      },
      telphone: '', // 手机号
      telCode: '' // 验证码
    }
  },
  mounted () {
    this.setStatusBar('dark')
  },
  methods: {
    /**
    * 验证手机号
    * @date: 2020/3/9
    */
    testTelNumber (phone) {
      if (!phone || phone === '') {
        this.$tkGlobal.toast.add('请输入手机号')
        return false
      }
      if (!(/^1[3456789]\d{9}$/.test(phone))) {
        this.$tkGlobal.toast.add('手机号码有误，请重新输入')
        return false
      }
      return true
    },
    /**
    * 获取验证码倒计时开启
    * @date: 2020/3/9
    */
    getCode (code = 60) {
      this.codeStatus = 0
      this.code = `${code--}S后重新发送`
      let timer = setInterval(() => {
        this.code = `${code--}S后重新发送`
        if (code < 0) {
          this.codeFailure = false
          clearInterval(timer)
          this.codeStatus = 1
          this.code = `重新发送`
        }
      }, 1000)
    },
    /**
     * @Description: 购物车计数
     * @author xiaozan
     * @date 2020/5/4
     */
    async getShoppingSum (user) {
      // 获取购物车计数
      let shoppingCart = await this.$tkParse.getList('/classes/shoppingCart', {
        params: {
          limit: 1,
          where: {
            user: user.objectId
          }
        }
      })
      let sum = 0
      if (!shoppingCart.length) {
        sum = 0
        this.$store.commit('setShoppingSum', 0)
        return
      }
      shoppingCart[0].data.forEach(s => {
        if (!s.commodityData) { s.commodityData = [] }
        sum += s.commodityData.length
      })
      this.$store.commit('setShoppingSum', sum)
    },
    /**
    * 处理跳转路由
    * @date: 2020/3/9
    */
    async routerAuth (res) {
      this.$store.commit('setSessionToken', res.sessionToken)
      this.$tkParse.setSessionToken(res.sessionToken)
      this.$store.commit('setUser', res)
      this.$replace('/')
      // await this.getShoppingSum(res) // 购物车计数
    },
    /**
    * 请求验证码接口
    * @date: 2020/3/9
    */
    async setCodeRequest () {
      let loginphone = this.telphone
      await this.$tkParse.post('/sms/sendCode', {
        phone: loginphone,
        templateId: 'GTrad'
      }).catch(e => {
        this.$tkGlobal.toast.add('短信发送失败')
        throw e
      })
      this.$tkGlobal.toast.add('短信发送成功')
    },
    async newSetCodeRequest () {
      console.log('newtest')
      // let loginphone = this.telphone
      // await this.$tkParse.post('/sms/sendCode', {
      //   phone: loginphone,
      //   templateId: 'LefwC1'
      // }).catch(e => {
      //   this.$tkGlobal.toast.add('短信发送失败')
      //   throw e
      // })
      // this.$tkGlobal.toast.add('短信发送成功')
      let loginphone = this.telphone
      await this.$tkParse.post('/sendSms/index', {
        phone: loginphone,
        code: this.generateCode()
      }).catch(e => {
        this.$tkGlobal.toast.add('短信发送失败')
        throw e
      })
      this.$tkGlobal.toast.add('短信发送成功')
    },
    // 生成验证码
    generateCode () {
      let captcha = '1234'
        .split('')
        .map(() => Math.floor(Math.random() * 10))
        .join('')
      return captcha
    },
    /**
    * 手机号登录接口
    * @date: 2020/3/9
    */
    async setTelLogin (loginObject) {
      let res = await this.$cloudAjax.post('/login/$login', loginObject).catch(e => {
        throw this.$tkGlobal.toast.add('登录失败')
      })
      return res.data
    },
    /**
    * 判断数据库有无此账号信息
    * @date: 2020/3/9
    */
    async judgePhone (phone) {
      let res = await this.$tkParse.getList(`/classes/_User`, {
        params: {
          limit: 1,
          where: {
            'phone': phone
          }
        }
      })
      if (res.length) {
        return true
      } else {
        return this.$tkGlobal.toast.add('未找到您的注册信息')
      }
    },
    /**
    * 获取验证码点击事件
    * @date: 2020/3/9
    */
    async handleGetCode () {
      // 验证手机号通过后执行下面获取验证码操作
      if (!this.testTelNumber(this.telphone)) { return }
      // 判断数据库有无此账号信息
      if (!await this.judgePhone(this.telphone)) { return }
      // 发送验证码间隔 disabled
      if (this.codeFailure) { return }
      // 发送获取验证码
      if (this.codeStatus === 1) {
        this.codeFailure = true
        this.getCode(60)
        // await this.setCodeRequest()
        await this.newSetCodeRequest()
      }
    },
    /**
    * 手机登录点击事件
    * @date: 2020/3/9
    */
    async handleTelLogin () {
      if (!this.agreementValue) { return this.$tkGlobal.toast.add('您未同意勾选协议') }
      this.loginDisabled = true
      let loginObject = {
        phone: this.telphone,
        code: this.telCode
      }
      let login = this.$refs.logo.validate()
      if (login.length) {
        this.loginDisabled = false
        return this.$tkGlobal.toast.add('手机号或验证码不正确，请重新输入')
      }
      let res = await this.setTelLogin(loginObject).catch(e => {
        this.loginDisabled = false
      })
      await this.routerAuth(res)
      this.$tkGlobal.toast.add('登录成功')
    }
  }
}
</script>
<style lang="scss" scoped>
  .login-container {
    background-color: #fff;
    padding: 0 43px;
    .form-mt {
      margin-top: 55px;
    }
    .btn-code{
      min-width: 84px;
      height: 30px;
      background-color: rgba(242, 242, 242, 1);
      border-radius: 5px;
      text-align: center;
      line-height: 30px;
      color: #BFBFBF;
      font-size: 12px;
      padding: 0 5px;
    }
    .btn-mt {
      margin-top: 65px;
    }
    /*提示样式*/
    .footer-line {
      width: 50px;
      height: 1px;
      border: 1px solid rgba(239, 239, 239, 1);
    }
    .footer-type {
      color: rgba(102, 102, 102, 1);
      .footer-type-margin-l {
      }
      .footer-type-margin-r {
      }
      .footer-type-margin-l-avatar {
        width: 50px;
        height: 50px;
        border: 1px solid rgba(239, 239, 239, 1);
        border-radius: 50%;
      }
    }
    .footer-caption {
      font-size: 10px;
      color: rgba(191, 191, 191, 1);
    }
  }
  .disabled-code {
    color: #999 !important;
  }
  .input-placeholder {
    ::placeholder {
      font-size: 15px;
      color: rgba(191, 191, 191, 1);
    }
  }
</style>
